import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { YatSprite } from '@pkg/components/YatSprite';
import {
    modalWrapperTransition,
    ModalWrapperVariant,
    modalWrapperVariants,
} from '@pkg/components/modals/primitives/Modal/Modal.motion';

interface WrapperProps {
    $moveUp?: boolean;
}

export const WishlistToastWrapper = styled(motion.div).attrs({
    variants: modalWrapperVariants,
    initial: ModalWrapperVariant.Hidden,
    animate: ModalWrapperVariant.Show,
    exit: ModalWrapperVariant.Hidden,
    transition: modalWrapperTransition,
})<WrapperProps>`
    background: linear-gradient(274.85deg, #6200de 36.63%, #ce88ff 89.13%, #bf28ff 100%);
    box-shadow: 0 4px 30px rgba(25, 9, 71, 0.75);
    border-radius: 100px;
    position: fixed;
    bottom: 40px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 300;
    transition: transform 0.3s ease-in-out;
    ${({ $moveUp }) =>
        $moveUp &&
        css`
            transform: translate(-50%, -120%);
        `};
`;

export const WishlistToastInner = styled.div<{ $center?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;

    background: linear-gradient(274.85deg, #221f3e 36.63%, #342945 89.13%);
    border-radius: 100px;
    padding-left: 18px;
    padding-right: 30px;
    margin: 1px;
    height: 78px;

    svg {
        width: 32px;
        height: 32px;
    }
    ${({ $center }) =>
        $center &&
        css`
            justify-content: center;
            padding-right: 30px;
            padding-left: 15px;
        `};
`;

export const Button = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.03em;
    color: #ffffff;
    padding-bottom: 3px;
    padding-top: 2px;
    border-bottom: 1px solid #ffffff;
    margin-left: 10px;
    cursor: pointer;
`;

export const ToastText = styled.div`
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.02em;
    color: #ffffff;
    margin: 0 12px;
`;

export const ToastLink = styled(Link)`
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.02em;
    color: #ffffff;
    cursor: pointer;
    margin: 0 12px;

    &:hover {
        text-decoration: underline;
    }
`;

export const StarIcon = styled(YatSprite)`
    font-size: 32px;
    flex-shrink: 0;
`;
